import DownloadMobileAppModal from './DownloadMobileAppModal';

export default DownloadMobileAppModal;
